import authSvc from '@efex-services/auth/authSvc';
import { useApiCall } from '@efexteam/use-api-call';
import { selectProfileData } from '@pages/profile/store/selectors';
import { fetchUserProfile } from '@pages/profile/store';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch } from '@/store';

const useDelete = ({ naturalPersonId }: { naturalPersonId: number }) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const userProfile = useSelector(selectProfileData);

  const { enterpriseId } = userProfile?.company || {};

  const {
    data,
    loading,
    error,
    invoke: deleteTeamMemberData,
  } = useApiCall(() => {
    if (!enterpriseId) {
      throw new Error('Enterprise ID is required');
    }
    return authSvc.deleteTeamMember(enterpriseId, naturalPersonId);
  });

  useEffect(() => {
    if (data && !error && !loading) {
      dispatch(fetchUserProfile());
      navigate('/profile?view=team');
    }
  }, [data, error, loading, navigate, dispatch]);

  return {
    loading,
    error,
    deleteTeamMemberData,
  };
};

export default useDelete;
